(() => {
  if (!window.gtmId) {
    console.error('GTM ID is not specified');
    return;
  }

  function injectGTM() {
    if (window.gtmInjected) return;
    window.gtmInjected = true;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'gtm.js',
      'gtm.start': Date.now(),
    });

    const firstScript = document.querySelector('script');
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(window.gtmId);

    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }

    document.removeEventListener('OneTrust:passed', injectGTM);
  }

  /**
   * @param {{ (): void; }} cb
   */
  function waitForOneTrust(cb, timeout = 5000, interval = 10) {
    const start = Date.now();
    (function check() {
      if (window.OneTrust) return cb();
      if (Date.now() - start >= timeout) return;
      setTimeout(check, interval);
    })();
  }

  document.addEventListener('OneTrust:passed', injectGTM);
  waitForOneTrust(() => injectGTM());
})();
